module.exports = __webpack_public_path__ + "static/img/company_history_shulin2018.3441c7cf.jpg";